import { CloudUpload as CloudUploadIcon } from "@mui/icons-material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  Alert,
} from "@mui/material";
import PropTypes from "prop-types";
import React, { useState } from "react";

function AttachPOModal({ open, onClose, onSubmit, loading }) {
  const [poNumber, setPoNumber] = useState("");
  const [poFile, setPoFile] = useState(null);
  const [error, setError] = useState("");

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.type !== "application/pdf") {
        setError("Only PDF files are allowed");
        setPoFile(null);
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        setError("File size must be less than 10MB");
        setPoFile(null);
        return;
      }
      setError("");
      setPoFile(file);
    }
  };

  const handleSubmit = () => {
    if (!poNumber.trim()) {
      setError("Please enter a PO number");
      return;
    }
    if (!poFile) {
      setError("Please select a PDF file");
      return;
    }
    setError("");
    onSubmit({ poNumber: poNumber.trim(), poFile });
  };

  const handleClose = () => {
    setPoNumber("");
    setPoFile(null);
    setError("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Attach Purchase Order</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 3 }}>
          {error && <Alert severity="error">{error}</Alert>}

          <TextField
            label="PO Number"
            value={poNumber}
            onChange={(e) => setPoNumber(e.target.value)}
            fullWidth
            required
            placeholder="Enter your purchase order number"
            disabled={loading}
          />

          <Box>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Upload PO Document (PDF only, max 10MB)
            </Typography>
            <Button
              variant="outlined"
              component="label"
              startIcon={<CloudUploadIcon />}
              fullWidth
              disabled={loading}
            >
              {poFile ? poFile.name : "Choose PDF File"}
              <input
                type="file"
                hidden
                accept="application/pdf"
                onChange={handleFileChange}
              />
            </Button>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={loading || !poNumber.trim() || !poFile}
        >
          {loading ? "Uploading..." : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

AttachPOModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default AttachPOModal;
